/**
 * Include your custom JavaScript here.
 */

/* Mega menu: rotate through every product in the New Launch collection. */
(function () {
  function shortName(title) {
    var parts = String(title || '').split('|');
    return (parts.length > 1 ? parts[1] : parts[0]).trim();
  }

  function sized(src) {
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=600';
  }

  function build(push, items) {
    var oldHeading = push.querySelector('[class*=PushHeading]');
    var oldSub = push.querySelector('[class*=PushSubHeading]');
    var headingClass = oldHeading ? oldHeading.className : 'MegaMenu__PushHeading Heading u-h6';
    var subClass = oldSub ? oldSub.className : 'MegaMenu__PushSubHeading Heading Text--subdued u-h7';

    var style = document.createElement('style');
    style.textContent =
      '.GMLaunch{display:block;text-align:center;transition:opacity .35s ease}' +
      '.GMLaunch.is-fading{opacity:0}' +
      '.GMLaunch__Img{display:block;width:100%;aspect-ratio:1/1;object-fit:cover;margin-bottom:18px}' +
      '.GMLaunch__Dots{display:flex;justify-content:center;gap:4px;margin-top:10px}' +
      '.GMLaunch__Dot{width:24px;height:24px;padding:0;border:0;background:none;cursor:pointer;display:flex;align-items:center;justify-content:center}' +
      '.GMLaunch__Dot span{width:8px;height:8px;border-radius:50%;background:currentColor;opacity:.35}' +
      '.GMLaunch__Dot[aria-current=true] span{opacity:1}' +
      '@media (prefers-reduced-motion: reduce){.GMLaunch{transition:none}}';
    document.head.appendChild(style);

    var link = document.createElement('a');
    link.className = 'MegaMenu__PushLink GMLaunch';
    var img = document.createElement('img');
    img.className = 'GMLaunch__Img';
    var heading = document.createElement('p');
    heading.className = headingClass;
    var sub = document.createElement('p');
    sub.className = subClass;
    link.appendChild(img);
    link.appendChild(heading);
    link.appendChild(sub);

    var dots = document.createElement('div');
    dots.className = 'GMLaunch__Dots';
    var dotEls = items.map(function (item, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'GMLaunch__Dot';
      b.setAttribute('aria-label', 'Show ' + shortName(item.title));
      b.appendChild(document.createElement('span'));
      b.addEventListener('click', function () { show(i); restart(); });
      dots.appendChild(b);
      return b;
    });

    var index = 0;
    var timer = null;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function render(i) {
      var item = items[i];
      link.href = '/products/' + item.handle;
      img.src = sized(item.images[0].src);
      img.alt = shortName(item.title);
      heading.textContent = shortName(item.title);
      sub.textContent = 'New launch';
      dotEls.forEach(function (d, n) { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      index = i;
    }

    function show(i) {
      if (reduced) { render(i); return; }
      link.classList.add('is-fading');
      setTimeout(function () { render(i); link.classList.remove('is-fading'); }, 350);
    }

    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      if (reduced || timer) return;
      timer = setInterval(function () { show((index + 1) % items.length); }, 3500);
    }
    function restart() { stop(); start(); }

    items.forEach(function (item) { var pre = new Image(); pre.src = sized(item.images[0].src); });

    push.innerHTML = '';
    push.appendChild(link);
    push.appendChild(dots);
    render(0);
    start();

    push.addEventListener('mouseenter', stop);
    push.addEventListener('mouseleave', start);
    push.addEventListener('focusin', stop);
    push.addEventListener('focusout', start);
  }

  function init() {
    var push = document.querySelector('.MegaMenu__Push');
    if (!push || !window.fetch) return;
    fetch('/collections/new-launch/products.json?limit=12')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var items = ((data && data.products) || []).filter(function (p) {
          return p.images && p.images.length;
        });
        if (items.length > 1) build(push, items);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Sale prices: show the % saved next to the struck-through price, unless the theme already prints one. */
(function () {
  function num(text) {
    var m = String(text || '').replace(/,/g, '').match(/\d+(\.\d+)?/);
    return m ? parseFloat(m[0]) : NaN;
  }

  function apply() {
    var i;
    var badges = document.querySelectorAll('.GMOff');
    for (i = 0; i < badges.length; i++) {
      var prev = badges[i].previousElementSibling;
      if (!prev || !prev.classList.contains('Price--compareAt')) badges[i].remove();
    }

    var olds = document.querySelectorAll('.Price--compareAt');
    for (i = 0; i < olds.length; i++) {
      var was = olds[i];
      var list = was.parentElement;
      if (!list) continue;
      var now = list.querySelector('.Price--highlight');
      var a = num(was.textContent);
      var b = now ? num(now.textContent) : NaN;
      var text = a > 0 && b > 0 && b < a ? Math.round((1 - b / a) * 100) + '% off' : '';
      var badge = list.querySelector('.GMOff');
      if (!badge) {
        if (!text || /\d\s*%/.test(list.textContent)) continue;
        badge = document.createElement('span');
        badge.className = 'GMOff';
        badge.textContent = text;
        was.insertAdjacentElement('afterend', badge);
      } else if (!text) {
        badge.remove();
      } else if (badge.textContent !== text) {
        badge.textContent = text;
      }
    }
  }

  function init() {
    var style = document.createElement('style');
    style.textContent = '.GMOff{margin-left:8px;color:#8a3f50;font-weight:600;white-space:nowrap}';
    document.head.appendChild(style);
    apply();
    if (!window.MutationObserver) return;
    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () { pending = null; apply(); }, 120);
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Product cards: the Add to cart button adds the card's first available variant. */
(function () {
  document.addEventListener('click', function (event) {
    var btn = event.target && event.target.closest ? event.target.closest('[data-gm-add]') : null;
    if (!btn || btn.disabled || !window.fetch) return;
    event.preventDefault();
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: Number(btn.getAttribute('data-gm-add')), quantity: 1 })
    })
      .then(function (r) {
        return r.json().then(function (d) { if (!r.ok) throw d; return d; });
      })
      .then(function (item) {
        btn.textContent = 'Added';
        document.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: { variant: item, quantity: 1 }
        }));
      })
      .catch(function () {
        btn.textContent = 'Could not add';
      })
      .then(function () {
        setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 1800);
      });
  });
})();
